import React from 'react'

import '@djthoms/pretty-checkbox'
import { Checkbox } from 'pretty-checkbox-react'
import styled from 'styled-components'

import { checkboxColors } from './store'

const StyledCheckbox = styled(Checkbox)`
  border-color: #007bff !important; /* Example color: blue */

  font-size: ${({ size }) => size || '16px'};
  &.pretty input:checked ~ .state.p-primary label:after,
  .pretty.p-toggle .state.p-primary label:after {
    background-color: ${({ styled }) => checkboxColors[styled].default}!important};
  }
  &.pretty input ~ .state.p-primary label:before,
  .pretty.p-toggle .state.p-primary label:before {
    border-color: ${({ styled }) => checkboxColors[styled].notChecked}!important}
`

const CheckboxV2 = ({
   bigger = false,
   hasFocus = false,
   variant = 'fill',
   shape = 'curve',
   label,
   size,
   checked,
   disabled = false,
   locked = false,
   onChange,
   name,
   styled = 'primary',
}) => (
    <StyledCheckbox
        color="primary"
        icon={
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-check"
            >
                <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
        }
        styled={styled}
        checked={checked}
        onChange={onChange}
        hasFocus={hasFocus}
        locked={locked}
        disabled={disabled}
        size={size}
        bigger={bigger}
        variant={variant}
        shape={shape}
        name={name}
    >
        {label}
    </StyledCheckbox>
)

export { CheckboxV2, checkboxColors }
